// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useState, useCallback} from 'react';
import cn from 'classnames';
import {type i_toast} from './types';
import {use_toast} from './toast_context';
import styles from './toast.module.less';

interface i_props {
    toast: i_toast;
    on_remove: (id: string)=>void;
}

export const Toast = (props: i_props)=>{
    const {toast, on_remove} = props;
    const {config} = use_toast();
    const [should_remove, set_should_remove] = useState(false);
    const [is_paused, set_is_paused] = useState(false);
    const [is_active, set_is_active] = useState(false);
    const with_animation = !!toast.with_animation;
    useEffect(()=>{
        if (!with_animation)
            return;
        const timer = setTimeout(()=>{
            return set_is_active(true);
        }, 10);
        return ()=>clearTimeout(timer);
    }, [with_animation]);
    useEffect(()=>{
        if (!toast.duration || is_paused)
            return;
        const timer = setTimeout(()=>{
            set_should_remove(true);
        }, toast.duration);
        return ()=>clearTimeout(timer);
    }, [toast.duration, is_paused]);
    useEffect(()=>{
        if (!should_remove)
            return;
        if (with_animation)
        {
            set_is_active(false);
            const timer = setTimeout(()=>{
                toast.on_close?.();
                return on_remove(toast.id);
            }, 500);
            return ()=>clearTimeout(timer);
        }
        toast.on_close?.();
        on_remove(toast.id);
    }, [should_remove, toast.id, toast.on_close, on_remove, with_animation]);
    const handle_mouse_enter = useCallback(()=>{
        if (toast.pause_on_hover)
            set_is_paused(true);
    }, [toast.pause_on_hover]);
    const handle_mouse_leave = useCallback(()=>{
        if (toast.pause_on_hover)
            set_is_paused(false);
    }, [toast.pause_on_hover]);
    const handle_close = useCallback(()=>{
        set_should_remove(true);
    }, []);
    return <div
      onMouseEnter={handle_mouse_enter}
      onMouseLeave={handle_mouse_leave}
      className={cn(
        styles.toast,
        {[styles.with_animation]: with_animation},
        {[styles.active]: with_animation && is_active},
        {[styles.exiting]: with_animation && should_remove && !is_active}
      )}
      data-type={toast.type}
      data-pos={toast.pos}
    >
      {toast.msg}
      {toast.closeable && <span data-elem="close_btn"
        onClick={handle_close}>
        {config.close_icon || '×'}
      </span>}
    </div>;
};
